import React from 'react';

const TimeDisplay = ({ value, unit }) => (
  <div className="rounded-sm border border-v5-neutral-300 py-[2px] px-2 text-center text-[8px] leading-normal md:text-[10px]">
    {value.toString().padStart(2, '0')} {unit}
  </div>
);

export default TimeDisplay;
